import { render, staticRenderFns } from "./strictBox2.vue?vue&type=template&id=70573791&scoped=true"
import script from "./strictBox2.vue?vue&type=script&lang=js"
export * from "./strictBox2.vue?vue&type=script&lang=js"
import style0 from "./strictBox2.vue?vue&type=style&index=0&id=70573791&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70573791",
  null
  
)

export default component.exports